import { Alert, Form, Input, Modal } from 'antd';
import { formatWindow } from '../policies/booking-labels';

interface CancelBookingModalProps {
  /** The booking being cancelled; null keeps the modal closed. */
  booking: { id: string; workshopName: string; startsAt: string; endsAt: string } | null;
  error: string | null;
  submitting: boolean;
  onSubmit: (id: string, reason: string) => Promise<boolean>;
  onClose: () => void;
}

/** A cancelled booking is kept, closed with the reason, so the reason is required. */
export function CancelBookingModal({ booking, error, submitting, onSubmit, onClose }: CancelBookingModalProps) {
  const [form] = Form.useForm<{ reason: string }>();

  async function submit({ reason }: { reason: string }) {
    if (booking && (await onSubmit(booking.id, reason))) onClose();
  }

  return (
    <Modal
      open={booking !== null}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText="Cancel booking"
      cancelText="Keep booking"
      okButtonProps={{ danger: true, loading: submitting }}
      title="Cancel this booking?"
      destroyOnHidden
    >
      {booking && (
        <p className="mt-0 text-muted">
          {booking.workshopName}, {formatWindow(booking.startsAt, booking.endsAt)}. The booking stays in the history with your reason.
        </p>
      )}
      {error && <Alert className="mb-5" type="error" title={error} showIcon />}
      <Form form={form} layout="vertical" requiredMark={false} onFinish={submit} disabled={submitting}>
        <Form.Item name="reason" label="Reason" rules={[{ required: true, whitespace: true, message: 'Say why it is cancelled' }]}>
          <Input.TextArea rows={3} maxLength={500} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
